import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { Row, Spinner, Button } from "reactstrap"
import API from "../../apis"
import ISGGB from "../../assets/images/ismsf.png"
import tunisie_rep from "../../assets/images/tn_rep.png"

const DetailEmploiEnseignant = props => {
  let enseignant_id = null
  let annee_id = null

  if (localStorage.getItem("userAuthEnseignant")) {
    const userAuthEnseignant = JSON.parse(
      localStorage.getItem("userAuthEnseignant")
    )

    enseignant_id = userAuthEnseignant?.user?.enseignant_id
    annee_id = userAuthEnseignant?.user?.annee_id
  }

  const [loading, setLoading] = useState(true)
  const [quarts, setQuarts] = useState([])
  const [jours, setJours] = useState([])
  const [pdfUrl, setPdfUrl] = useState(null)
  const [error, setError] = useState(null)

  const previousUrl = useRef(null)

  const anneeScolaire = JSON.parse(
    localStorage.getItem("anneeScolaire")
  )

  const annee = anneeScolaire?.label

  const isMobile =
    /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true)
        setError(null)

        /*
        |--------------------------------------------------------------------------
        | Charger les données emploi enseignant
        |--------------------------------------------------------------------------
        */

        const resE = await API.post("emploi/get_by_id", {
          enseignant_id: enseignant_id,
          semestre_id: props.semestre_value,
          annee_id: annee_id,
        })

        if (
          resE?.data?.emploi &&
          resE.data.emploi.length > 0
        ) {
          setQuarts(resE.data.emploi[0]?.quarts || [])
          setJours(resE.data.emploi[0]?.jours || [])
        }

        /*
        |--------------------------------------------------------------------------
        | Charger le PDF
        |--------------------------------------------------------------------------
        */

        const responsePdf = await API.post(
          "enseignant/get_emploi_enseignant_pdf",
          {
            annee_id: annee_id,
            semestre_id: props.semestre_value,
            enseignant_id: enseignant_id,
          },
          {
            responseType: "blob",
          }
        )

        console.log(
          "Content-Type PDF :",
          responsePdf.headers?.["content-type"]
        )

        console.log(
          "Taille PDF :",
          responsePdf.data?.size
        )

        /*
        |--------------------------------------------------------------------------
        | Vérification du PDF
        |--------------------------------------------------------------------------
        */

        if (
          !responsePdf.data ||
          responsePdf.data.size === 0
        ) {
          throw new Error(
            "Le fichier PDF retourné est vide."
          )
        }

        /*
        |--------------------------------------------------------------------------
        | Création du Blob
        |--------------------------------------------------------------------------
        */

        const blob = new Blob([responsePdf.data], {
          type: "application/pdf",
        })

        /*
        |--------------------------------------------------------------------------
        | Nettoyage ancienne URL
        |--------------------------------------------------------------------------
        */

        if (previousUrl.current) {
          URL.revokeObjectURL(previousUrl.current)
        }

        /*
        |--------------------------------------------------------------------------
        | Création nouvelle URL
        |--------------------------------------------------------------------------
        */

        const url = URL.createObjectURL(blob)

        previousUrl.current = url

        setPdfUrl(url)
      } catch (error) {
        console.error(
          "Erreur chargement emploi/PDF enseignant :",
          error
        )

        setPdfUrl(null)

        setError(
          "Impossible de charger l'emploi du temps."
        )
      } finally {
        setLoading(false)
      }
    }

    if (
      enseignant_id &&
      annee_id &&
      props.semestre_value
    ) {
      loadData()
    } else {
      setLoading(false)
    }

    return () => {
      if (previousUrl.current) {
        URL.revokeObjectURL(previousUrl.current)

        previousUrl.current = null
      }
    }
  }, [
    enseignant_id,
    annee_id,
    props.semestre_value,
  ])

  /*
  |--------------------------------------------------------------------------
  | Ouvrir PDF
  |--------------------------------------------------------------------------
  */

  const openPdf = () => {
    if (!pdfUrl) {
      return
    }

    const link = document.createElement("a")

    link.href = pdfUrl
    link.target = "_blank"
    link.rel = "noopener noreferrer"

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  }

  /*
  |--------------------------------------------------------------------------
  | Télécharger PDF
  |--------------------------------------------------------------------------
  */

  const downloadPdf = () => {
    if (!pdfUrl) {
      return
    }

    const link = document.createElement("a")

    link.href = pdfUrl

    link.download = `emploi_enseignant_${enseignant_id}.pdf`

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  }

  /*
  |--------------------------------------------------------------------------
  | Loading
  |--------------------------------------------------------------------------
  */

  if (loading) {
    return (
      <div
        style={{
          paddingTop: "50px",
          textAlign: "center",
        }}
      >
        <Spinner
          type="grow"
          color="primary"
        />

        <h4
          style={{
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          Chargement ...
        </h4>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Row>

        <div className="container">

          <div
            className="row"
            style={{
              paddingTop: "30px",
            }}
          >

            {/* FRANÇAIS */}

            <div
              className="col"
              style={{
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              République Tunisienne

              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
               {" Ministère de l'enseignement supérieur,"}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                de la Recherche Scientifique
              </div>

              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  paddingTop: "10px",
                }}
              >
                Université de Sfax
              </div>

              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Institut Supérieur de Musique de Sfax
              </div>
            </div>

            {/* LOGO */}

            <div
              className="col"
              style={{
                position: "relative",
                textAlign: "center",
              }}
            >
              <img
                alt="ISMSF"
                src={ISGGB}
                style={{
                  width: "70%",
                  maxWidth: "120px",
                }}
              />
            </div>

            {/* LOGO TUNISIE */}

            <div
              className="col"
              style={{
                position: "relative",
                textAlign: "center",
              }}
            >
              <img
                alt="Tunisie"
                src={tunisie_rep}
                style={{
                  width: "28%",
                  maxWidth: "70px",
                }}
              />
            </div>

            {/* ARABE */}

            <div
              className="col"
              style={{
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              الجمهورية التونسية

              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                وزارة التعليم العالي والبحث العلمي
              </div>

              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  paddingTop: "10px",
                }}
              >
                جامعة ﺻﻔﺎﻗﺲ
              </div>

              <div
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                اﻟﻤﻌﻬﺪ اﻟﻌﺎﻟﻲ ﻟﻠﻤﻮﺳﻴﻘﻰ ﺑﺼﻔﺎﻗﺲ
              </div>

            </div>

          </div>

          <hr
            style={{
              width: "100%",
              marginTop: "2px",
              color: "black",
            }}
          />

        </div>

        {/* PDF */}

        <div
          style={{
            width: "100%",
            padding: "0px 15px",
          }}
        >

          {error ? (

            <div
              style={{
                textAlign: "center",
                padding: "30px",
                color: "red",
              }}
            >
              {error}
            </div>

          ) : pdfUrl ? (

            <React.Fragment>

              {/* MOBILE */}

              {isMobile ? (

                <div
                  style={{
                    textAlign: "center",
                    padding: "30px 10px",
                  }}
                >

                  <div
                    style={{
                      marginBottom: "20px",
                      fontSize: "16px",
                    }}
                  >
                    Votre emploi du temps est disponible.
                  </div>

                  <Button
                    color="primary"
                    onClick={openPdf}
                    style={{
                      width: "100%",
                      maxWidth: "350px",
                      padding: "12px",
                      marginBottom: "15px",
                    }}
                  >
                  {"  Ouvrir l'emploi du temps"}
                  </Button>

                  <br />

                  <Button
                    color="secondary"
                    onClick={downloadPdf}
                    style={{
                      width: "100%",
                      maxWidth: "350px",
                      padding: "12px",
                    }}
                  >
                    Télécharger le PDF
                  </Button>

                </div>

              ) : (

                /* PC */

                <iframe
                  src={pdfUrl}
                  title="Emploi enseignant"
                  width="100%"
                  height="900px"
                  style={{
                    border: "1px solid #ddd",
                  }}
                />

              )}

            </React.Fragment>

          ) : (

            <div
              style={{
                textAlign: "center",
                padding: "30px",
              }}
            >
              Aucun emploi disponible.
            </div>

          )}

        </div>

      </Row>
    </React.Fragment>
  )
}

export default DetailEmploiEnseignant

DetailEmploiEnseignant.propTypes = {
  history: PropTypes.object,

  semestre_value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),

  semestre_label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}
